<template>
  <div class="section" style="overflow-y: scroll; overflow-x: hidden;">
    <div class="columns is-fullheight is-vcentered">
      <div class="column is-12">
        <div class="container">
          <div class="logo">
            <img
              :src="require(`@/assets/logos/${domain}.png`)"
              width="50%"
              style="max-width: 400px; min-width: 300px;"
            />
          </div>
          <h1 class="title is-1 " style="color: darkorange;">
            {{ $t(`OBT1${domain}`) }} <br />
            {{ $t(`OBT2${domain}`) }} <br />
            {{ $t(`OBT3${domain}`) }}
          </h1>
          <h2 class="subtitle is-4 " style="">
            {{ $t(`OBST1${domain}`) }} <br />
            {{ $t(`OBST2${domain}`) }} <br /><br />
            {{ $t(`OBST3${domain}`) }}
          </h2>
        </div>
        <div class="container">
          <br />
          <h2
            class="subtitle is-2 postScriptum"
            style="color: var(--rosa-dark-eco);"
          >
            {{ $t(`OBCL${domain}`) }}
          </h2>
          <button
            @click="goToInvitation"
            class="button is-rounded is-pink is-large"
            style="margin: auto; margin-bottom: 0px;"
          >
            {{ $t('Iniciar') }}
          </button>
        </div>
      </div>
    </div>
    <div id="mundo">
      <img src="~@/assets/bola_mundo.png" alt="" />
    </div>
    <div id="people">
      <img src="~@/assets/peopleStart.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  components: {},
  mixins: [Fetcher],
  computed: {
    domain() {
      return this.$store.state.domain
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  mounted() {
    this.$jbUtils.toggle(false)
    this.$store.commit('layout/FULL_PAGE', true)
  },
  beforeDestroy() {
    this.$store.commit('layout/FULL_PAGE', false)
    document.body.style.backgroundColor = 'white'
  },
  methods: {
    ...mapActions('invitationCode', ['getInvitationCodeDetails']),
    goToInvitation() {
      this.$router.push({ name: 'onBoard.neofintech.verifyInvitation' })
    },
    goToPhase1() {
      this.$router.push({ name: 'onBoard.neofintech.phase1' })
    },
    goToNeolicitador() {
      this.$router.push({ name: 'onBoard.neolicitador.phase1.1' })
    }
  }
}
</script>

<style scoped>
.hero {
  background: linear-gradient(90deg, white, var(--rosa-eco) 33);
}

#mundo {
  position: absolute;
  top: 0;
  right: -100px;
  width: 60vh;
}
#people {
  position: absolute;
  width: 35%;
  top: 45%;
  right: 0;
  mix-blend-mode: multiply;
}

@media (max-width: 768px) {
  #mundo,
  #people {
    display: none;
  }
}
</style>
